import { useMemo } from "react";
import dayjs from "dayjs";
import { Select } from "@/components/catalyst/select";

function getTimezones(): string[] {
  if (typeof Intl.supportedValuesOf === "function") {
    return Intl.supportedValuesOf("timeZone");
  }
  return [dayjs.tz.guess(), "UTC"];
}

function offsetLabel(zone: string): string {
  const minutes = dayjs().tz(zone).utcOffset();
  const sign = minutes >= 0 ? "+" : "-";
  const abs = Math.abs(minutes);
  const h = String(Math.floor(abs / 60)).padStart(2, "0");
  const m = String(abs % 60).padStart(2, "0");
  return `UTC${sign}${h}:${m}`;
}

export function TimezoneSelect({
  value,
  onChange,
  className,
}: {
  value: string;
  onChange: (zone: string) => void;
  className?: string;
}) {
  const grouped = useMemo(() => {
    const zones = getTimezones();
    const map = new Map<string, string[]>();
    for (const z of zones) {
      const region = z.includes("/") ? z.split("/")[0] : "Other";
      if (!map.has(region)) map.set(region, []);
      map.get(region)!.push(z);
    }
    return Array.from(map.entries()).sort(([a], [b]) => a.localeCompare(b));
  }, []);

  return (
    <Select
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {grouped.map(([region, zones]) => (
        <optgroup key={region} label={region}>
          {zones.map((z) => (
            <option key={z} value={z}>
              {z.replace(/_/g, " ")} ({offsetLabel(z)})
            </option>
          ))}
        </optgroup>
      ))}
    </Select>
  );
}
